
// import { FiChevronRight } from "react-icons/fi";
// import {
//   MdMonitor, MdDeviceHub, MdTimeline, MdBugReport,
//   MdStorage, MdSpeed, MdOpenInNew
// } from "react-icons/md";
// import { HiOutlineServer, HiOutlineChip } from "react-icons/hi";
// import { TbTopologyRing, TbApi } from "react-icons/tb";
// import serviceImg from "../../assets/services.png";
// import overviewImg from "../../assets/overviewservice.png";
// import overview1Img from "../../assets/overviewservice1.png";
// import instanceImg from "../../assets/instanceservice.png";
// import instance1Img from "../../assets/instanceservice1.png";
// import instance2Img from "../../assets/instanceservice2.png";
// import servicecomImg from "../../assets/servicecom.png";
// import endpointImg from "../../assets/endpoint.png";
// import endpoint1Img from "../../assets/endpoint1.png";
// import topologyImg from "../../assets/topology.png";
// import tracesImg from "../../assets/traces.png";
// import traces1Img from "../../assets/traces1.png";
// import traces2Img from "../../assets/traces2.png";
// import traces3Img from "../../assets/traces3.png";
// import traces4Img from "../../assets/traces4.png";
// import traces5Img from "../../assets/traces5.png";
// import traces6Img from "../../assets/traces6.png";
// import traces7Img from "../../assets/traces7.png";
// import traces8Img from "../../assets/traces8.png";
// import logImg from "../../assets/logs.png";
// import log1Img from "../../assets/logs1.png";
// import databaseImg from "../../assets/database.png";

// /* ─── tiny shared primitives ─── */
// const Breadcrumb = ({ items }) => (
//   <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-8">
//     {items.map((item, i) => (
//       <span key={i} className="flex items-center gap-2">
//         {i > 0 && <FiChevronRight className="text-[14px]" />}
//         {item.href
//           ? <a className="hover:text-primary hover:underline" href={item.href}>{item.label}</a>
//           : <span className="text-slate-900 dark:text-white">{item.label}</span>}
//       </span>
//     ))}
//   </nav>
// );

// const SectionIcon = ({ icon: Icon, color = "primary" }) => (
//   <div className={`w-8 h-8 rounded bg-${color}/10 text-${color} flex items-center justify-center`}>
//     <Icon className="text-xl" />
//   </div>
// );

// const SectionHeading = ({ icon, label, id, color = "primary/10 text-primary" }) => (
//   <div className="flex items-center gap-3 mb-4">
//     <div className={`w-8 h-8 rounded bg-${color} flex items-center justify-center`}>
//       {icon}
//     </div>
//     <h2 id={id} className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white scroll-mt-24">
//       {label}
//     </h2>
//   </div>
// );

// const StepItem = ({ num, children }) => (
//   <li className="flex gap-3 items-start">
//     <span className="mt-0.5 min-w-[1.5rem] h-6 w-6 rounded-full bg-primary/10 text-primary text-xs font-bold flex items-center justify-center">{num}</span>
//     <span className="text-slate-600 dark:text-slate-400 leading-relaxed">{children}</span>
//   </li>
// );

// const TabBadge = ({ label }) => (
//   <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-700">
//     {label}
//   </span>
// );

// const MetricCard = ({ icon: Icon, label, desc }) => (
//   <div className="flex gap-3 p-4 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm hover:shadow-md transition-shadow">
//     <div className="w-9 h-9 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
//       <Icon className="text-lg" />
//     </div>
//     <div>
//       <p className="text-sm font-semibold text-slate-800 dark:text-white">{label}</p>
//       <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5 leading-snug">{desc}</p>
//     </div>
//   </div>
// );

// const FilterTag = ({ label }) => (
//   <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium bg-orange-50 dark:bg-orange-950/30 text-orange-700 dark:text-orange-300 border border-orange-200 dark:border-orange-800">
//     <span className="w-1.5 h-1.5 rounded-full bg-orange-400 dark:bg-orange-500"></span>
//     {label}
//   </span>
// );

// /* ─── main export ─── */
// export function renderServices() {
//   return (
//     <main className="transition-opacity duration-300 space-y-16">

//       {/* Breadcrumbs */}
//       <Breadcrumb items={[
//         { label: "Netraa APM" },
//         { label: "Analyze & Explore" },
//         { label: "Apps" },
//         { label: "Home" },
//         { label: "Services" }
//       ]} />

//       {/* ══════════════════════════════════════════
//           PAGE HEADING
//       ══════════════════════════════════════════ */}
//       <div className="border-b border-gray-200 dark:border-gray-800 pb-4">
//         <h1 className="text-4xl lg:text-5xl font-black tracking-tight text-slate-900 dark:text-white leading-snug mb-4">
//           <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
//             Services:
//           </span>{" "}
//           Centralized Application Monitoring
//         </h1>
//         <p className="text-lg lg:text-xl text-slate-500 dark:text-slate-400 mb-6 leading-relaxed font-light">
//           The Services page provides a centralized view of all monitored application services, serving as the primary entry point for operational visibility. It enables teams to quickly evaluate the health, availability, and performance of services across the environment. Each service is monitored in real time, with key metrics such as availability, response time, and error rate presented through clear and actionable indicators.
//         </p>
//       </div>

//       {/* ══════════════════════════════════════════
//           SECTION: Accessing the Services Page
//       ══════════════════════════════════════════ */}
//       <section id="accessing-services" className="scroll-mt-24">
//         <SectionHeading
//           icon={<HiOutlineServer className="text-xl" />}
//           label="Accessing the Services Page"
//           id="accessing-services"
//           color="primary/10 text-primary"
//         />
//         <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//           Follow the steps below to access the Services page in Netraa APM.
//         </p>

//         <ol className="space-y-3">
//           <StepItem num={1}>
//             Log in to the <strong className="text-slate-800 dark:text-slate-200">Netraa platform</strong> using your credentials.
//           </StepItem>
//           <StepItem num={2}>
//             Upon successful authentication, you will be automatically redirected to the <strong className="text-slate-800 dark:text-slate-200">Services page</strong>, which serves as the default landing page and provides an overview of all monitored application services.
//           </StepItem>
//         </ol>

//         <img
//           src={serviceImg}
//           alt="Services Page – Overview"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />
//       </section>

//       {/* ══════════════════════════════════════════
//           SECTION: Exploring a Service
//       ══════════════════════════════════════════ */}
//       <section id="exploring-service" className="scroll-mt-24 space-y-6">
//         <SectionHeading
//           icon={<MdDeviceHub className="text-xl" />}
//           label="Exploring a Service"
//           id="exploring-service"
//           color="primary/10 text-primary"
//         />
//         <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//           To explore a specific service, click on the desired service from the Services page. This opens the dedicated <strong className="text-slate-800 dark:text-slate-200">Service Details page</strong>, which provides comprehensive insights into the selected service.
//         </p>

//         <div>
//           <p className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3 uppercase tracking-wide">
//             The Service Details page is organized into the following tabs:
//           </p>
//           <div className="flex flex-wrap gap-2">
//             {[
//               "Overview", "Instance", "Endpoint", "Topology", "Trace", "Log", "Database"
//             ].map(tab => <TabBadge key={tab} label={tab} />)}
//           </div>
//         </div>

//         {/* Tab descriptions */}
//         <div className="divide-y divide-slate-100 dark:divide-slate-800 rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden">
//           {[
//             { tab: "Overview", desc: "Displays key service health and performance metrics." },
//             { tab: "Instance", desc: "Provides details about the individual service instances." },
//             { tab: "Endpoint", desc: "Shows endpoint-level performance and request metrics." },
//             { tab: "Topology", desc: "Visualizes service dependencies and interactions within the application architecture." },
//             { tab: "Trace", desc: "Enables distributed tracing for end-to-end request analysis." },
//             { tab: "Log", desc: "Provides access to logs associated with the selected service." },
//             { tab: "Database", desc: "Displays database-related performance metrics and interactions linked to the service." },
//           ].map(({ tab, desc }) => (
//             <div key={tab} className="flex gap-4 px-5 py-3.5 bg-white dark:bg-slate-900 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
//               <span className="min-w-[90px] text-sm font-semibold text-primary">{tab}</span>
//               <span className="text-sm text-slate-600 dark:text-slate-400">{desc}</span>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* ══════════════════════════════════════════
//           SECTION: Overview
//       ══════════════════════════════════════════ */}
//       <section id="overview" className="scroll-mt-24 space-y-6">
//         <SectionHeading
//           icon={<MdMonitor className="text-xl" />}
//           label="Overview"
//           id="overview"
//           color="primary/10 text-primary"
//         />
//         <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//           The Overview page provides a comprehensive summary of the selected service, presenting key health, performance, and operational metrics in a single view. It enables users to quickly assess service status, monitor critical indicators, and identify potential issues that may require further investigation.
//         </p>
//         <img
//           src={overviewImg}
//           alt="Service Overview"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />
//         <img
//           src={overview1Img}
//           alt="Overview – Metrics Detail"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />
//       </section>

//       {/* ══════════════════════════════════════════
//           SECTION: Instance
//       ══════════════════════════════════════════ */}
//       <section id="instance" className="scroll-mt-24 space-y-6">
//         <SectionHeading
//           icon={<HiOutlineChip className="text-xl" />}
//           label="Instance"
//           id="instance"
//           color="primary/10 text-primary"
//         />
//         <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//           The Instance view provides visibility into all instances where the selected service is deployed. It enables users to access and monitor multiple service instances from a centralized location, making it easier to analyze instance-level performance and behavior.
//         </p>
//         <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//           In addition to deployment information, this page presents key performance metrics for each instance:
//         </p>

//         <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
//           <MetricCard icon={MdSpeed} label="Instance Load" desc="Displays the workload handled by each instance." />
//           <MetricCard icon={MdTimeline} label="Success Rate" desc="Indicates the percentage of successful requests processed." />
//           <MetricCard icon={MdTimeline} label="Latency" desc="Shows the response time of the instance." />
//           <MetricCard icon={MdBugReport} label="Slow Instances" desc="Identifies instances experiencing higher-than-normal response times." />
//         </div>

//         <img
//           src={instanceImg}
//           alt="Instance List View"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />

//         <div className="bg-amber-50 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-800 rounded-xl p-5">
//           <p className="text-sm text-amber-800 dark:text-amber-300 leading-relaxed">
//             <strong>Selecting an instance</strong> opens the Instance Overview page, which provides a detailed view of the selected instance. This page presents instance-specific health, performance, and operational metrics, enabling users to monitor its behavior, analyze resource utilization, and investigate potential performance issues.
//           </p>
//         </div>

//         <img
//           src={instance1Img}
//           alt="Instance Overview"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />
//         <img
//           src={instance2Img}
//           alt="Instance Metrics Detail"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />

//         {/* ── Traces and Logs sub-section ── */}
//         <div className="space-y-4 pt-4">
//           <h3 className="text-lg font-bold text-slate-900 dark:text-white">Traces and Logs</h3>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             The Traces and Logs views within the Instance Overview page provide the same functionality and capabilities as those available at the service level. Users can leverage these views to analyze distributed traces, investigate request execution flows, review application logs, and troubleshoot issues specific to the selected instance.
//           </p>
//           <div className="grid sm:grid-cols-2 gap-4">
//             <img
//           src={serviceImg}
//           alt="Instance Traces"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />
//             <img
//           src={serviceImg}
//           alt="Instance Logs"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />
//           </div>
//         </div>

//         {/* ── Sources sub-section ── */}
//         <div className="space-y-4 pt-4">
//           <h3 className="text-lg font-bold text-slate-900 dark:text-white">Sources</h3>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             The Sources view provides runtime-specific metrics for the technologies used by the selected service instance. It offers detailed insights into application performance and resource utilization across different runtime environments, including:
//           </p>
//           <div className="grid sm:grid-cols-2 gap-3">
//             {[
//               "JVM (Java Virtual Machine) metrics",
//               "Python Virtual Machine (PVM) metrics",
//               "Golang runtime metrics",
//               ".NET runtime metrics",
//             ].map(item => (
//               <div key={item} className="flex items-center gap-2 px-4 py-3 rounded-lg bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700">
//                 <span className="w-2 h-2 rounded-full bg-primary shrink-0"></span>
//                 <span className="text-sm text-slate-700 dark:text-slate-300">{item}</span>
//               </div>
//             ))}
//           </div>
//             <img
//           src={servicecomImg}
//           alt="JVM Metrics"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />
//         </div>
//       </section>

//       {/* ══════════════════════════════════════════
//           SECTION: Endpoint
//       ══════════════════════════════════════════ */}
//       <section id="endpoint" className="scroll-mt-24 space-y-6">
//         <SectionHeading
//           icon={<TbApi className="text-xl" />}
//           label="Endpoint"
//           id="endpoint"
//           color="primary/10 text-primary"
//         />
//         <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//           The Endpoint view provides a consolidated list of all endpoints associated with the selected service. It enables users to monitor endpoint-level performance and identify potential bottlenecks within the application.
//         </p>
//         <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//           For each endpoint, the following key metrics are displayed:
//         </p>

//         <div className="grid sm:grid-cols-3 gap-4">
//           <MetricCard icon={MdTimeline} label="Load (Calls/Minute)" desc="Indicates the volume of requests handled by the endpoint." />
//           <MetricCard icon={MdSpeed} label="Success Rate" desc="Shows the percentage of successfully processed requests." />
//           <MetricCard icon={MdBugReport} label="Slowest Endpoints" desc="Highlights endpoints with higher response times." />
//         </div>

//           <img
//           src={endpointImg}
//           alt="Endpoint List – Overview"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />

//         <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl p-5 border border-slate-200 dark:border-slate-700 space-y-2">
//           <p className="text-sm font-semibold text-slate-800 dark:text-slate-200">Endpoint Details Table</p>
//           <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
//             The Endpoint Details table provides comprehensive performance and traffic metrics for each endpoint. Available metrics include <span className="font-medium text-slate-700 dark:text-slate-300">Load, Success Rate, Failure Count, Failure Rate, Latency, Hits,</span> and HTTP response code distributions (1xx, 2xx, 3xx, 4xx, and 5xx).
//           </p>
//           <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
//             Users can customize the table view by selecting the desired columns through the <strong className="text-slate-700 dark:text-slate-300">View</strong> option. A search bar is provided to quickly locate and filter endpoints.
//           </p>
//         </div>

//         <div className="bg-amber-50 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-800 rounded-xl p-5">
//           <p className="text-sm text-amber-800 dark:text-amber-300 leading-relaxed">
//             Selecting an endpoint from the Endpoint Details table opens the <strong>Endpoint Details page</strong>, which provides in-depth insights into the selected endpoint — including Overview, Traces, and Logs sections.
//           </p>
//         </div>

//           <img
//           src={endpoint1Img}
//           alt="Endpoint Performance Metrics"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />
//       </section>

//       {/* ══════════════════════════════════════════
//           SECTION: Topology
//       ══════════════════════════════════════════ */}
//       <section id="topology" className="scroll-mt-24 space-y-6">
//         <SectionHeading
//           icon={<TbTopologyRing className="text-xl" />}
//           label="Topology"
//           id="topology"
//           color="primary/10 text-primary"
//         />
//         <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//           The Topology view provides a graphical representation of the service and its connected components within the application ecosystem. It visualizes the relationships, dependencies, and interactions between services, databases, and other monitored components, enabling users to understand the overall architecture and request flow.
//         </p>
//         <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//           This view helps identify service dependencies, analyze communication patterns, and troubleshoot issues by providing a clear picture of how the selected service interacts with other components in the environment.
//         </p>
//         <img
//           src={topologyImg}
//           alt="Service Topology Map"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />
//       </section>

//       {/* ══════════════════════════════════════════
//           SECTION: Traces
//       ══════════════════════════════════════════ */}
//       <section id="traces" className="scroll-mt-24 space-y-6">
//         <SectionHeading
//           icon={<MdTimeline className="text-xl" />}
//           label="Traces"
//           id="traces"
//           color="primary/10 text-primary"
//         />
//         <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//           The Traces view provides access to all distributed traces associated with the endpoints of the selected service. It enables users to track request execution paths across services and components, offering end-to-end visibility into application transactions.
//         </p>
//         <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//           This view helps in analyzing request flows, identifying performance bottlenecks, diagnosing failures, and performing root cause analysis by providing detailed trace information for each request processed by the service.
//         </p>

//         <img
//           src={tracesImg}
//           alt="Traces List"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />

//         <div>
//           <p className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-4 uppercase tracking-wide">
//             Available filter options:
//           </p>
//           <div className="flex flex-wrap gap-2">
//             {[
//               "Instance", "API Name", "Status", "Trace ID",
//               "Minimum Duration", "Maximum Duration", "Status Code"
//             ].map(f => <FilterTag key={f} label={f} />)}
//           </div>
//         </div>

//         <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl p-5 border border-slate-200 dark:border-slate-700 space-y-2">
//           <p className="text-sm font-semibold text-slate-800 dark:text-slate-200">Trace Details</p>
//           <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
//             Selecting a trace opens the <strong className="text-slate-700 dark:text-slate-300">Trace Details view</strong>, which provides method-level visibility into the complete request execution flow. The Trace Details table presents a detailed breakdown of the operations performed during the transaction, enabling users to analyze the sequence of method calls, execution times, dependencies, and interactions across services.
//           </p>
//         </div>

//         {/* <img
//           src={traces1Img}
//           alt="Trace Details View"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         /> */}

//         <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
//           Selecting a method within the Trace Details view opens a detailed pop-up displaying additional information about the selected method. This pop-up provides method-specific attributes, execution details, timing information, and other relevant metadata.
//         </p>

//         <img
//           src={traces2Img}
//           alt="Method Detail Pop-up"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />
//         <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">To customize and refine the method-level view within the Trace Details page, users can apply a variety of filters. </p>
//          <img
//           src={traces3Img}
//           alt="Method Detail Pop-up"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />
//          {/* View options — each with its own title, description, and image */}
//         <div className="space-y-8">

//           {/* View Table */}
//           <div className="space-y-2">
//             <h3 className="text-base font-bold text-slate-900 dark:text-white">View Table</h3>
//             <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//               The View Table option displays all methods involved in the selected trace in a tabular format.
//             </p>
//             <img
//               src={traces4Img}
//               alt="View Table"
//               className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//             />
//           </div>

//           {/* View List */}
//           <div className="space-y-2">
//             <h3 className="text-base font-bold text-slate-900 dark:text-white">View List</h3>
//             <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//               The View List option presents a graphical representation of the methods involved in the selected trace.
//             </p>
//             <img
//               src={traces5Img}
//               alt="View List"
//               className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//             />
//           </div>

//           {/* View Tree */}
//           <div className="space-y-2">
//             <h3 className="text-base font-bold text-slate-900 dark:text-white">View Tree</h3>
//             <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//               The View Tree option displays the method execution flow in a hierarchical tree structure.
//             </p>
//             <img
//               src={traces6Img}
//               alt="View Tree"
//               className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//             />
//           </div>

//           {/* View Statistics */}
//           <div className="space-y-2">
//             <h3 className="text-base font-bold text-slate-900 dark:text-white">View Statistics</h3>
//             <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//               The View Statistics option provides aggregated statistical insights for the methods involved in the selected trace.
//             </p>
//             <img
//               src={traces7Img}
//               alt="View Statistics"
//               className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//             />
//           </div>

//           {/* View Logs */}
//           <div className="space-y-2">
//             <h3 className="text-base font-bold text-slate-900 dark:text-white">View Logs</h3>
//             <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//               The View Logs option displays all logs associated with the selected trace, provided that log data is available.
//             </p>
//             <img
//               src={traces8Img}
//               alt="View Logs"
//               className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//             />
//           </div>

//         </div>

//         {/* Info button */}
//         <div className="space-y-2">
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             The <strong className="text-slate-800 dark:text-slate-200">Info button</strong> displays the unique Trace ID of the selected trace. This identifier can be used to locate and reference the trace during analysis and troubleshooting.
//           </p>
//         </div>

//       </section>

//       {/* ══════════════════════════════════════════
//           SECTION: Logs
//       ══════════════════════════════════════════ */}
//       <section id="logs" className="scroll-mt-24 space-y-6">
//         <SectionHeading
//           icon={<MdBugReport className="text-xl" />}
//           label="Logs"
//           id="logs"
//           color="primary/10 text-primary"
//         />
//         <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//           The Logs page provides access to all logs associated with the selected service. It enables users to monitor application activity, review operational events, and investigate issues by viewing service-generated log records in a centralized location.
//         </p>
//         <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//           This view helps users correlate logs with traces and performance metrics, facilitating efficient troubleshooting, root cause analysis, and operational monitoring of the service.
//         </p>

//         <img
//           src={logImg}
//           alt="Logs Page"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />
//         {/* <img
//           src={log1Img}
//           alt="Logs – Filtered View"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         /> */}

//         <div>
//           <p className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-4 uppercase tracking-wide">
//             Available filter options:
//           </p>
//           <div className="flex flex-wrap gap-2">
//             {[
//               "Instance", "Endpoint", "Trace ID", "Status",
//               "Include Content", "Exclude Content"
//             ].map(f => <FilterTag key={f} label={f} />)}
//           </div>
//         </div>

//         <div className="divide-y divide-slate-100 dark:divide-slate-800 rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden">
//           {[
//             { filter: "Instance", desc: "Filters logs generated by a specific service instance." },
//             { filter: "Endpoint", desc: "Filters logs associated with a particular endpoint or API." },
//             { filter: "Trace ID", desc: "Filters logs related to a specific trace, enabling seamless correlation between logs and distributed traces." },
//             { filter: "Status", desc: "Filters logs based on their severity level, such as Info, Debug, Warning, or Error." },
//             { filter: "Include Content", desc: "Displays only log entries containing the specified text or keywords." },
//             { filter: "Exclude Content", desc: "Excludes log entries containing the specified text or keywords from the results." },
//           ].map(({ filter, desc }) => (
//             <div key={filter} className="flex gap-4 px-5 py-3.5 bg-white dark:bg-slate-900 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
//               <span className="min-w-[120px] text-sm font-semibold text-primary">{filter}</span>
//               <span className="text-sm text-slate-600 dark:text-slate-400">{desc}</span>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* ══════════════════════════════════════════
//           SECTION: Database
//       ══════════════════════════════════════════ */}
//       <section id="database" className="scroll-mt-24 space-y-6">
//         <SectionHeading
//           icon={<MdStorage className="text-xl" />}
//           label="Database"
//           id="database"
//           color="primary/10 text-primary"
//         />
//         <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//           The Database page provides database-related performance metrics and insights for the selected service. It offers visibility into database interactions, helping users monitor database activity and identify potential bottlenecks affecting application performance.
//         </p>
//         <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//           The page provides an overview of key database metrics:
//         </p>

//         <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
//           <MetricCard icon={MdSpeed} label="Top Slow Queries" desc="Lists the most time-consuming database queries." />
//           <MetricCard icon={MdTimeline} label="Avg DB Response Time" desc="Average time taken to process database requests." />
//           <MetricCard icon={MdTimeline} label="DB Access Success Rate" desc="Percentage of successful database access attempts." />
//           <MetricCard icon={MdDeviceHub} label="Database Traffic" desc="Volume of requests hitting the database layer." />
//         </div>

//         <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl p-5 border border-slate-200 dark:border-slate-700">
//           <p className="text-sm font-semibold text-slate-800 dark:text-slate-200 mb-1">Database Access Latency Distribution</p>
//           <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
//             Visualizes how database query latency is distributed across time buckets, helping identify outlier queries impacting performance.
//           </p>
//         </div>
//           <img
//           src={databaseImg}
//           alt="Database Overview"
//           className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
//         />
//       </section>

//     </main>
//   );
// }


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import {
  MdMonitor, MdDeviceHub, MdTimeline, MdBugReport,
  MdStorage, MdSpeed, MdOpenInNew
} from "react-icons/md";
import { HiOutlineServer, HiOutlineChip } from "react-icons/hi";
import { TbTopologyRing, TbApi } from "react-icons/tb";
import serviceImg from "../../assets/services.png";
import overviewImg from "../../assets/overviewservice.png";
import overview1Img from "../../assets/overviewservice1.png";
import instanceImg from "../../assets/instanceservice.png";
import instance1Img from "../../assets/instanceservice1.png";
import instance2Img from "../../assets/instanceservice2.png";
import servicecomImg from "../../assets/servicecom.png";
import endpointImg from "../../assets/endpoint.png";
import endpoint1Img from "../../assets/endpoint1.png";
import topologyImg from "../../assets/topology.png";
import tracesImg from "../../assets/traces.png";
import traces1Img from "../../assets/traces1.png";
import traces2Img from "../../assets/traces2.png";
import traces3Img from "../../assets/traces3.png";
import traces4Img from "../../assets/traces4.png";
import traces5Img from "../../assets/traces5.png";
import traces6Img from "../../assets/traces6.png";
import traces7Img from "../../assets/traces7.png";
import traces8Img from "../../assets/traces8.png";
import logImg from "../../assets/logs.png";
import log1Img from "../../assets/logs1.png";
import databaseImg from "../../assets/database.png";

/* ─── tiny shared primitives ─── */
const Breadcrumb = ({ items }) => (
  <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-8">
    {items.map((item, i) => (
      <span key={i} className="flex items-center gap-2">
        {i > 0 && <FiChevronRight className="text-[14px]" />}
        {item.href
          ? <a className="hover:text-primary hover:underline" href={item.href}>{item.label}</a>
          : <span className="text-slate-900 dark:text-white">{item.label}</span>}
      </span>
    ))}
  </nav>
);

const SectionHeading = ({ icon, label, id, color = "primary/10 text-primary" }) => (
  <div className="flex items-center gap-3 mb-4">
    <div className={`w-8 h-8 rounded bg-${color} flex items-center justify-center`}>
      {icon}
    </div>
    <h2 id={id} className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white scroll-mt-24">
      {label}
    </h2>
  </div>
);

const StepItem = ({ num, children }) => (
  <li className="flex gap-3 items-start">
    <span className="mt-0.5 min-w-[1.5rem] h-6 w-6 rounded-full bg-primary/10 text-primary text-xs font-bold flex items-center justify-center">{num}</span>
    <span className="text-slate-600 dark:text-slate-400 leading-relaxed">{children}</span>
  </li>
);

const MetricCard = ({ icon: Icon, label, desc }) => (
  <div className="flex gap-3 p-4 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm hover:shadow-md transition-shadow">
    <div className="w-9 h-9 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
      <Icon className="text-lg" />
    </div>
    <div>
      <p className="text-sm font-semibold text-slate-800 dark:text-white">{label}</p>
      <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5 leading-snug">{desc}</p>
    </div>
  </div>
);

const FilterTag = ({ label }) => (
  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium bg-orange-50 dark:bg-orange-950/30 text-orange-700 dark:text-orange-300 border border-orange-200 dark:border-orange-800">
    <span className="w-1.5 h-1.5 rounded-full bg-orange-400 dark:bg-orange-500"></span>
    {label}
  </span>
);

const TABS = ["Overview", "Instance", "Endpoint", "Topology", "Trace", "Log", "Database"];

const TAB_DESCRIPTIONS = [
  { tab: "Overview", desc: "Displays key service health and performance metrics." },
  { tab: "Instance", desc: "Provides details about the individual service instances." },
  { tab: "Endpoint", desc: "Shows endpoint-level performance and request metrics." },
  { tab: "Topology", desc: "Visualizes service dependencies and interactions within the application architecture." },
  { tab: "Trace", desc: "Enables distributed tracing for end-to-end request analysis." },
  { tab: "Log", desc: "Provides access to logs associated with the selected service." },
  { tab: "Database", desc: "Displays database-related performance metrics and interactions linked to the service." },
];

export function renderServices() {
  return <ServicesComponent />;
}

function ServicesComponent() {
  /* ─── main export ─── */
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(null); // null = show all

  const handleTabClick = (tab) => {
    setActiveTab(tab === activeTab ? null : tab);
  };

  const showSection = (tab) => activeTab === null || activeTab === tab;

  const visibleDescriptions = activeTab
    ? TAB_DESCRIPTIONS.filter(t => t.tab === activeTab)
    : TAB_DESCRIPTIONS;

  return (
    <main className="transition-opacity duration-300 space-y-16">

      {/* Breadcrumbs */}
      <Breadcrumb items={[
        { label: "Netraa APM" },
        { label: "Analyze & Explore" },
        { label: "Apps" },
        { label: "Home" },
        { label: "Services" }
      ]} />

      {/* PAGE HEADING */}
      <div className="border-b border-gray-200 dark:border-gray-800 pb-6 mb-6">

        {/* TOP ROW → heading + button */}
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4 scroll-mt-24" id="intro">

          {/* HEADING */}
          <h1 className="text-3xl lg:text-5xl font-extrabold text-text-main dark:text-white tracking-tight leading-tight max-w-[800px]">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
              Services
            </span>
            <span className="text-orange-500">:</span>{" "}
            Centralized Application Monitoring
          </h1>

          {/* BUTTON */}
          <div className="flex-shrink-0">
            <button
              onClick={() => {
                navigate("/agentsetup", { state: { scrollTo: "TechnologyAgent" } });
              }}
              className="px-5 py-3 bg-orange-50 dark:bg-orange-950/20 border border-orange-200 dark:border-orange-800 text-orange-600 dark:text-orange-400 rounded-xl font-semibold whitespace-nowrap hover:bg-orange-100 dark:hover:bg-orange-900/30 transition-colors inline-flex items-center gap-2"
            >
              <FiChevronRight className="rotate-180 w-4 h-4" />
              Instrument a Service
            </button>
          </div>

        </div>

        {/* SECOND ROW → FULL WIDTH PARAGRAPH */}
        <p className="mt-4 text-lg lg:text-xl text-slate-500 dark:text-slate-400 leading-relaxed font-light max-w-[900px]">
          The Services page provides a centralized view of all monitored application services, serving as the primary entry point for operational visibility. It enables teams to quickly evaluate the health, availability, and performance of services across the environment. Each service is monitored in real time, with key metrics such as availability, response time, and error rate presented through clear and actionable indicators.
        </p>

      </div>

      {/* SECTION: Accessing the Services Page */}
      <section id="accessing-services" className="scroll-mt-24">
        <SectionHeading
          icon={<HiOutlineServer className="text-xl" />}
          label="Accessing the Services Page"
          id="accessing-services"
          color="primary/10 text-primary"
        />
        <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
          Follow the steps below to access the Services page in Netraa APM.
        </p>
        <ol className="space-y-3">
          <StepItem num={1}>
            Log in to the <strong className="text-slate-800 dark:text-slate-200">Netraa platform</strong> using your credentials.
          </StepItem>
          <StepItem num={2}>
            Upon successful authentication, you will be automatically redirected to the <strong className="text-slate-800 dark:text-slate-200">Services page</strong>, which serves as the default landing page and provides an overview of all monitored application services.
          </StepItem>
        </ol>
        <img src={serviceImg} alt="Services Page – Overview" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
      </section>

      {/* SECTION: Exploring a Service */}
      <section id="exploring-service" className="scroll-mt-24 space-y-6">
        <SectionHeading
          icon={<MdDeviceHub className="text-xl" />}
          label="Exploring a Service"
          id="exploring-service"
          color="primary/10 text-primary"
        />
        <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
          To explore a specific service, click on the desired service from the Services page. This opens the dedicated <strong className="text-slate-800 dark:text-slate-200">Service Details page</strong>, which provides comprehensive insights into the selected service.
        </p>

        {/* ── Interactive Tab Strip ── */}
        <div>
          <p className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3 uppercase tracking-wide">
            The Service Details page is organized into the following tabs:
          </p>
          <div className="flex flex-wrap gap-2">
            {TABS.map(tab => (
              <button
                key={tab}
                onClick={() => handleTabClick(tab)}
                className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border transition-all duration-200 cursor-pointer
                  ${activeTab === tab
                    ? "bg-primary text-white border-primary shadow-sm shadow-primary/30 scale-100"
                    : "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-700 hover:border-primary/50 hover:text-primary dark:hover:text-primary"
                  }`}
              >
                {tab}
              </button>
            ))}

            {/* Show All button — only visible when a tab is active */}
            {activeTab !== null && (
              <button
                onClick={() => setActiveTab(null)}
                className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border border-dashed border-orange-400 text-orange-500 bg-orange-50 dark:bg-orange-950/20 hover:bg-orange-100 dark:hover:bg-orange-900/30 transition-all duration-200"
              >
                Show All
              </button>
            )}
          </div>
        </div>

        {/* ── Tab Description Table (filtered) ── */}
        <div className="divide-y divide-slate-100 dark:divide-slate-800 rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden">
          {visibleDescriptions.map(({ tab, desc }) => (
            <div
              key={tab}
              className={`flex gap-4 px-6 py-3.5 transition-colors duration-200
                ${activeTab === tab
                  ? "bg-orange-50 dark:bg-orange-950/20"
                  : "bg-white dark:bg-slate-900 hover:bg-slate-50 dark:hover:bg-slate-800/50"
                }`}
            >
              <span className="min-w-[90px] text-sm font-semibold text-primary">{tab}</span>
              <span className="text-sm text-slate-600 dark:text-slate-400">{desc}</span>
            </div>
          ))}
        </div>
      </section>

      {/* SECTION: Overview */}
      {showSection("Overview") && (
        <section id="overview" className="scroll-mt-24 space-y-6" style={{ animation: "fadeIn 0.3s ease" }}>
          <SectionHeading
            icon={<MdMonitor className="text-xl" />}
            label="Overview"
            id="overview"
            color="primary/10 text-primary"
          />
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            The Overview page provides a comprehensive summary of the selected service, presenting key health, performance, and operational metrics in a single view. It enables users to quickly assess service status, monitor critical indicators, and identify potential issues that may require further investigation.
          </p>
          <img src={overviewImg} alt="Service Overview" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
          <img src={overview1Img} alt="Overview – Metrics Detail" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
        </section>
      )}

      {/* SECTION: Instance */}
      {showSection("Instance") && (
        <section id="instance" className="scroll-mt-24 space-y-6" style={{ animation: "fadeIn 0.3s ease" }}>
          <SectionHeading
            icon={<HiOutlineChip className="text-xl" />}
            label="Instance"
            id="instance"
            color="primary/10 text-primary"
          />
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            The Instance view provides visibility into all instances where the selected service is deployed. It enables users to access and monitor multiple service instances from a centralized location, making it easier to analyze instance-level performance and behavior.
          </p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            In addition to deployment information, this page presents key performance metrics for each instance:
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <MetricCard icon={MdSpeed} label="Instance Load" desc="Displays the workload handled by each instance." />
            <MetricCard icon={MdTimeline} label="Success Rate" desc="Indicates the percentage of successful requests processed." />
            <MetricCard icon={MdTimeline} label="Latency" desc="Shows the response time of the instance." />
            <MetricCard icon={MdBugReport} label="Slow Instances" desc="Identifies instances experiencing higher-than-normal response times." />
          </div>
          <img src={instanceImg} alt="Instance List View" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
          <div className="bg-amber-50 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-800 rounded-xl p-5">
            <p className="text-sm text-amber-800 dark:text-amber-300 leading-relaxed">
              <strong>Selecting an instance</strong> opens the Instance Overview page, which provides a detailed view of the selected instance. This page presents instance-specific health, performance, and operational metrics, enabling users to monitor its behavior, analyze resource utilization, and investigate potential performance issues.
            </p>
          </div>
          <img src={instance1Img} alt="Instance Overview" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
          <img src={instance2Img} alt="Instance Metrics Detail" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />

          <div className="space-y-4 pt-4">
            <h3 className="text-lg font-bold text-slate-900 dark:text-white">Traces and Logs</h3>
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
              The Traces and Logs views within the Instance Overview page provide the same functionality and capabilities as those available at the service level. Users can leverage these views to analyze distributed traces, investigate request execution flows, review application logs, and troubleshoot issues specific to the selected instance.
            </p>
            <div className="grid sm:grid-cols-2 gap-4">
              <img src={serviceImg} alt="Instance Traces" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
              <img src={serviceImg} alt="Instance Logs" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
            </div>
          </div>

          <div className="space-y-4 pt-4">
            <h3 className="text-lg font-bold text-slate-900 dark:text-white">Sources</h3>
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
              The Sources view provides runtime-specific metrics for the technologies used by the selected service instance. It offers detailed insights into application performance and resource utilization across different runtime environments, including:
            </p>
            <div className="grid sm:grid-cols-2 gap-3">
              {[
                "JVM (Java Virtual Machine) metrics",
                "Python Virtual Machine (PVM) metrics",
                "Golang runtime metrics",
                ".NET runtime metrics",
              ].map(item => (
                <div key={item} className="flex items-center gap-2 px-4 py-3 rounded-lg bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700">
                  <span className="w-2 h-2 rounded-full bg-primary shrink-0"></span>
                  <span className="text-sm text-slate-700 dark:text-slate-300">{item}</span>
                </div>
              ))}
            </div>
            <img src={servicecomImg} alt="JVM Metrics" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
          </div>
        </section>
      )}

      {/* SECTION: Endpoint */}
      {showSection("Endpoint") && (
        <section id="endpoint" className="scroll-mt-24 space-y-6" style={{ animation: "fadeIn 0.3s ease" }}>
          <SectionHeading
            icon={<TbApi className="text-xl" />}
            label="Endpoint"
            id="endpoint"
            color="primary/10 text-primary"
          />
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            The Endpoint view provides a consolidated list of all endpoints associated with the selected service. It enables users to monitor endpoint-level performance and identify potential bottlenecks within the application.
          </p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            For each endpoint, the following key metrics are displayed:
          </p>
          <div className="grid sm:grid-cols-3 gap-4">
            <MetricCard icon={MdTimeline} label="Load (Calls/Minute)" desc="Indicates the volume of requests handled by the endpoint." />
            <MetricCard icon={MdSpeed} label="Success Rate" desc="Shows the percentage of successfully processed requests." />
            <MetricCard icon={MdBugReport} label="Slowest Endpoints" desc="Highlights endpoints with higher response times." />
          </div>
          <img src={endpointImg} alt="Endpoint List – Overview" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
          <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl p-5 border border-slate-200 dark:border-slate-700 space-y-2">
            <p className="text-sm font-semibold text-slate-800 dark:text-slate-200">Endpoint Details Table</p>
            <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
              The Endpoint Details table provides comprehensive performance and traffic metrics for each endpoint. Available metrics include <span className="font-medium text-slate-700 dark:text-slate-300">Load, Success Rate, Failure Count, Failure Rate, Latency, Hits,</span> and HTTP response code distributions (1xx, 2xx, 3xx, 4xx, and 5xx).
            </p>
            <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
              Users can customize the table view by selecting the desired columns through the <strong className="text-slate-700 dark:text-slate-300">View</strong> option. A search bar is provided to quickly locate and filter endpoints.
            </p>
          </div>
          <div className="bg-amber-50 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-800 rounded-xl p-5">
            <p className="text-sm text-amber-800 dark:text-amber-300 leading-relaxed">
              Selecting an endpoint from the Endpoint Details table opens the <strong>Endpoint Details page</strong>, which provides in-depth insights into the selected endpoint — including Overview, Traces, and Logs sections.
            </p>
          </div>
          <img src={endpoint1Img} alt="Endpoint Performance Metrics" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
        </section>
      )}

      {/* SECTION: Topology */}
      {showSection("Topology") && (
        <section id="topology" className="scroll-mt-24 space-y-6" style={{ animation: "fadeIn 0.3s ease" }}>
          <SectionHeading
            icon={<TbTopologyRing className="text-xl" />}
            label="Topology"
            id="topology"
            color="primary/10 text-primary"
          />
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            The Topology view provides a graphical representation of the service and its connected components within the application ecosystem. It visualizes the relationships, dependencies, and interactions between services, databases, and other monitored components, enabling users to understand the overall architecture and request flow.
          </p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            This view helps identify service dependencies, analyze communication patterns, and troubleshoot issues by providing a clear picture of how the selected service interacts with other components in the environment.
          </p>
          <img src={topologyImg} alt="Service Topology Map" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
        </section>
      )}

      {/* SECTION: Traces */}
      {showSection("Trace") && (
        <section id="traces" className="scroll-mt-24 space-y-6" style={{ animation: "fadeIn 0.3s ease" }}>
          <SectionHeading
            icon={<MdTimeline className="text-xl" />}
            label="Traces"
            id="traces"
            color="primary/10 text-primary"
          />
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            The Traces view provides access to all distributed traces associated with the endpoints of the selected service. It enables users to track request execution paths across services and components, offering end-to-end visibility into application transactions.
          </p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            This view helps in analyzing request flows, identifying performance bottlenecks, diagnosing failures, and performing root cause analysis by providing detailed trace information for each request processed by the service.
          </p>
          <img src={tracesImg} alt="Traces List" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
          <div>
            <p className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-4 uppercase tracking-wide">Available filter options:</p>
            <div className="flex flex-wrap gap-2">
              {["Instance", "API Name", "Status", "Trace ID", "Minimum Duration", "Maximum Duration", "Status Code"].map(f => <FilterTag key={f} label={f} />)}
            </div>
          </div>
          <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl p-5 border border-slate-200 dark:border-slate-700 space-y-2">
            <p className="text-sm font-semibold text-slate-800 dark:text-slate-200">Trace Details</p>
            <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
              Selecting a trace opens the <strong className="text-slate-700 dark:text-slate-300">Trace Details view</strong>, which provides method-level visibility into the complete request execution flow. The Trace Details table presents a detailed breakdown of the operations performed during the transaction, enabling users to analyze the sequence of method calls, execution times, dependencies, and interactions across services.
            </p>
          </div>
          <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
            Selecting a method within the Trace Details view opens a detailed pop-up displaying additional information about the selected method. This pop-up provides method-specific attributes, execution details, timing information, and other relevant metadata.
          </p>
          <img src={traces2Img} alt="Method Detail Pop-up" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
          <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">To customize and refine the method-level view within the Trace Details page, users can apply a variety of filters.</p>
          <img src={traces3Img} alt="Method Detail Pop-up" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
          <div className="space-y-8">
            {[
              { title: "View Table", desc: "The View Table option displays all methods involved in the selected trace in a tabular format.", img: traces4Img },
              { title: "View List", desc: "The View List option presents a graphical representation of the methods involved in the selected trace.", img: traces5Img },
              { title: "View Tree", desc: "The View Tree option displays the method execution flow in a hierarchical tree structure.", img: traces6Img },
              { title: "View Statistics", desc: "The View Statistics option provides aggregated statistical insights for the methods involved in the selected trace.", img: traces7Img },
              { title: "View Logs", desc: "The View Logs option displays all logs associated with the selected trace, provided that log data is available.", img: traces8Img },
            ].map(({ title, desc, img }) => (
              <div key={title} className="space-y-2">
                <h3 className="text-base font-bold text-slate-900 dark:text-white">{title}</h3>
                <p className="text-slate-600 dark:text-slate-400 leading-relaxed">{desc}</p>
                <img src={img} alt={title} className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
              </div>
            ))}
          </div>
          <div className="space-y-2">
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
              The <strong className="text-slate-800 dark:text-slate-200">Info button</strong> displays the unique Trace ID of the selected trace. This identifier can be used to locate and reference the trace during analysis and troubleshooting.
            </p>
          </div>
        </section>
      )}

      {/* SECTION: Logs */}
      {showSection("Log") && (
        <section id="logs" className="scroll-mt-24 space-y-6" style={{ animation: "fadeIn 0.3s ease" }}>
          <SectionHeading
            icon={<MdBugReport className="text-xl" />}
            label="Logs"
            id="logs"
            color="primary/10 text-primary"
          />
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            The Logs page provides access to all logs associated with the selected service. It enables users to monitor application activity, review operational events, and investigate issues by viewing service-generated log records in a centralized location.
          </p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            This view helps users correlate logs with traces and performance metrics, facilitating efficient troubleshooting, root cause analysis, and operational monitoring of the service.
          </p>
          <img src={logImg} alt="Logs Page" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
          <div>
            <p className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-4 uppercase tracking-wide">Available filter options:</p>
            <div className="flex flex-wrap gap-2">
              {["Instance", "Endpoint", "Trace ID", "Status", "Include Content", "Exclude Content"].map(f => <FilterTag key={f} label={f} />)}
            </div>
          </div>
          <div className="divide-y divide-slate-100 dark:divide-slate-800 rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden">
            {[
              { filter: "Instance", desc: "Filters logs generated by a specific service instance." },
              { filter: "Endpoint", desc: "Filters logs associated with a particular endpoint or API." },
              { filter: "Trace ID", desc: "Filters logs related to a specific trace, enabling seamless correlation between logs and distributed traces." },
              { filter: "Status", desc: "Filters logs based on their severity level, such as Info, Debug, Warning, or Error." },
              { filter: "Include Content", desc: "Displays only log entries containing the specified text or keywords." },
              { filter: "Exclude Content", desc: "Excludes log entries containing the specified text or keywords from the results." },
            ].map(({ filter, desc }) => (
              <div key={filter} className="flex gap-4 px-5 py-3.5 bg-white dark:bg-slate-900 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                <span className="min-w-[120px] text-sm font-semibold text-primary">{filter}</span>
                <span className="text-sm text-slate-600 dark:text-slate-400">{desc}</span>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* SECTION: Database */}
      {showSection("Database") && (
        <section id="database" className="scroll-mt-24 space-y-6" style={{ animation: "fadeIn 0.3s ease" }}>
          <SectionHeading
            icon={<MdStorage className="text-xl" />}
            label="Database"
            id="database"
            color="primary/10 text-primary"
          />
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            The Database page provides database-related performance metrics and insights for the selected service. It offers visibility into database interactions, helping users monitor database activity and identify potential bottlenecks affecting application performance.
          </p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            The page provides an overview of key database metrics:
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <MetricCard icon={MdSpeed} label="Top Slow Queries" desc="Lists the most time-consuming database queries." />
            <MetricCard icon={MdTimeline} label="Avg DB Response Time" desc="Average time taken to process database requests." />
            <MetricCard icon={MdTimeline} label="DB Access Success Rate" desc="Percentage of successful database access attempts." />
            <MetricCard icon={MdDeviceHub} label="Database Traffic" desc="Volume of requests hitting the database layer." />
          </div>
          <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl p-5 border border-slate-200 dark:border-slate-700">
            <p className="text-sm font-semibold text-slate-800 dark:text-slate-200 mb-1">Database Access Latency Distribution</p>
            <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
              Visualizes how database query latency is distributed across time buckets, helping identify outlier queries impacting performance.
            </p>
          </div>
          <img src={databaseImg} alt="Database Overview" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
        </section>
      )}

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

    </main>
  );
}